import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BYPASS_LOG } from '../../interceptors/loading';
import { AccessApp } from '../../models/accessApp.model';
import { EditProfile, Preference, UserData } from '../../models/userData.model';
import { UserNavigationHistory } from '../../models/user_navigation_history.model';
import { HeadbandProps } from '../../user.store';

@Injectable({
  providedIn: 'root',
})
export class QueryService {
  private http = inject(HttpClient);

  postUserNavigationHistory(data: UserNavigationHistory.Create): Observable<HttpResponse<UserNavigationHistory.Create>> {
    return this.http.post<UserNavigationHistory.Create>(`${environment.apiUrl}/user-navigation-history`, data, {
      observe: 'response',
    });
  }

  getAccessApp(): Observable<HttpResponse<AccessApp[]>> {
    return this.http.get<AccessApp[]>(`${environment.apiUrl}/user-account-has-access-to-application-with-role/for-menu`, {
      observe: 'response',
    });
  }

  getUserInfos(): Observable<HttpResponse<UserData>> {
    return this.http.get<UserData>(`${environment.apiUrl}/user-account/user-connected`, {
      observe: 'response',
    });
  }

  disconnect(): Observable<HttpResponse<unknown>> {
    return this.http.get<unknown>(`${environment.apiUrl}/auth/logout`, { observe: 'response' });
  }

  refreshTokenexpiration(token: string) {
    return this.http.post(
      `${environment.apiUrl}/common/refresh-token-expiration`,
      { token },
      {
        observe: 'response',
      },
    );
  }

  refreshTokenInfo() {
    return this.http.get(`${environment.apiUrl}/common/refresh-token-info`, { observe: 'response' });
  }

  updateProdile(data: EditProfile): Observable<HttpResponse<Partial<EditProfile>>> {
    return this.http.patch<Partial<EditProfile>>(`${environment.apiUrl}/auth/edit-profile`, data, {
      observe: 'response',
    });
  }

  getAlertDev(id_application: number): Observable<HttpResponse<HeadbandProps[]>> {
    return this.http.get<HeadbandProps[]>(`${environment.apiUrl}/alert-dev/by-application-and-user?id_application=${id_application}`, {
      observe: 'response',
    });
  }

  setAlertDevPreference(data: { id_alert_dev: number; hide: boolean }): Observable<HttpResponse<unknown>> {
    return this.http.post(`${environment.apiUrl}/alert-dev-preference`, data, {
      observe: 'response',
      context: new HttpContext().set(BYPASS_LOG, true),
    });
  }

  getMailPreferences(): Observable<HttpResponse<Preference.MailSetting[]>> {
    return this.http.get<Preference.MailSetting[]>(`${environment.apiUrl}/application-preference/mail`, { observe: 'response' });
  }

  updatePreference(payload: Preference.Update): Observable<HttpResponse<Preference.Update>> {
    return this.http.post<Preference.Update>(`${environment.apiUrl}/preference`, payload, {
      observe: 'response',
    });
  }

  addBookmark(id_application: number): Observable<HttpResponse<unknown>> {
    const body = { id_application, message: 'ok' };
    return this.http.post(`${environment.apiUrl}/navbar-bookmark`, body, { observe: 'response' });
  }

  deleteBookmark(id: number): Observable<HttpResponse<unknown>> {
    return this.http.delete(`${environment.apiUrl}/navbar-bookmark/${id}`, { observe: 'response' });
  }
}
